import React, { Component } from "react"

export default class PrintLayout extends Component {
  render() {
    const { children } = this.props

    return children
  }
}
